import { Client, IClient } from './../models/Client.model';
import { ClientService } from './../_services/Client.service';


import { Component, OnInit } from "@angular/core";
import { FormBuilder, Validators } from "@angular/forms";
import { AuthService } from "../_services/auth.service";
import { RoleService } from "../_services/role.service";

import { ActivatedRoute } from "@angular/router";
import { User } from "../models/user.model";

import { Role } from "../models/role.model";
import { UserService } from "../_services/user.service";
import { Ng2ImgMaxService } from "ng2-img-max";
import { DomSanitizer } from "@angular/platform-browser";
import { AdresseService } from '../_services/Adresse.service';
import { Adresse } from '../models/Adresse.model';

@Component({
  selector: "app-user",
  templateUrl: "./clientUpdate.component.html",
  styleUrls: ["./clientUpdate.component.css"],
})
export class ClientUpdateComponent implements OnInit {
  form: any = {};
  isSuccessful = false;
  isSignUpFailed = false;
  errorMessage = "";
  tabaddresss: Adresse[];
  user: User;
  client: Client;
  adresse: Adresse;
  items = ["Admin", "Modérateur", "Utilisateur"];
  Regions = ["Dakar", "Thies", "Kaolack","Fatick","TAMBA","KAFFRINE","KEDOUGOU","PODOR","MATAM","DIOURBEL","SAINT LOUIS","KOLDA","ZIGUINCHOR"];
  selected: any;
  selectedRegion: any;
  update = false;
  roles: Role[];
  uploadedImage: File;
  uploadedImage2: String;
  imagePreview2: string;
  photo: any;
  photoUpdate: any;
  avatar = "assets/img/avatars/user.png";
  ROLE = ["Utilisateur"];
  constructor(
    private formBuilder: FormBuilder,
    private authService: AuthService,
    private userService: UserService,
    private clientService: ClientService,
    private adresseService: AdresseService,
    private roleService: RoleService,
    private route: ActivatedRoute,
    private ng2ImgMax: Ng2ImgMaxService,
    public sanitizer: DomSanitizer
  ) { }

  ngOnInit() {
    this.user = new User();
    this.client = new Client();
    this.adresse = new Adresse();
    this.tabaddresss=[];
    this.tabaddresss.push(this.adresse)
    if (this.route.snapshot.paramMap.get("id")) {
      this.loadRoles();
      this.update = true;
      this.clientService
        .getOneData(this.route.snapshot.paramMap.get("id"))
        .subscribe((data: any) => {
          this.client = data;
          console.log(this.client);
          this.tabaddresss=this.client.adresses;
          this.client.user.role = [];
          for (let r of this.client.user.roles) {
            if (r.name == "ROLE_USER") {
              this.client.user.role.push("Utilisateur");
            }
          }
          //console.log("Photo", this.user.photo);
          this.photoUpdate = this.client.user.photo;
          this.updateForm(this.client);
        });
    }
     ///////
     var pageHeader = $(".content-header").find("b");
     var adminForm = $(".admin-form");
     var buttons = adminForm.find(".button");
     var Panel = adminForm.find(".panel");
     setTimeout(function () {
       adminForm.addClass("theme-success");
       Panel.addClass("panel-success");
       pageHeader.addClass("text-success");

       buttons.removeClass().addClass("button btn-success");
     }, 800);
     //////
  }
  addRow(index) {
    this.adresse = new Adresse();
    this.tabaddresss.push(this.adresse);
    console.log(this.tabaddresss);
    return true;
}
  getValues() {
    console.log("Select roles", this.form.roles);
  }

  loadRoles() {
    this.roleService.getAll().subscribe((data: User[]) => {
      this.roles = data;
      console.log("Roles", this.roles);
    });
  }

  updateForm(client: IClient): void {
    this.form.id = client.id;
    this.form.nom = client.user.nom;
    this.form.prenom = client.user.prenom;
    this.form.tel = client.tel;
    this.form.sexe = client.sexe;
    this.form.cni = client.cni;
    this.form.username = client.user.username;
    this.form.role = client.user.role;
    this.form.email = client.user.email;
    this.form.password = client.user.password;
    this.form.etat = client.etat;
    this.form.photo = client.user.photo;
    this.form.roles = client.user.roles;
  }

  onSubmit() {
    if (this.user.id != null) {
      console.log("Form", this.form);
      this.client = this.form;
      this.user = this.client.user;
      this.user.roles = [];

      for (let r of this.form.role) {
        if (r == "Utilisateur") {
          for (let b of this.roles) {
            if (b.name == "ROLE_USER") {
              this.user.roles.push(b);
            }
          }
        }
      }
      if (this.photo == null) {
        this.user.photo = this.photoUpdate;
      } else {
        this.user.photo = this.photo;
      }

      // this.userService.update(this.user.id, this.user).subscribe((data) => {
      //   console.log("Updated man!!");
      //   //console.log(data);
      //   this.retour();
      // });
    } else {
      this.form.etat = true;
      //console.log("Form", this.form);
      this.client.cni = this.form.cni;
      this.client.tel = this.form.tel;
      this.client.sexe = this.form.sexe;
      this.client.etat = this.form.etat;
      this.user.email = this.form.email;
      this.user.password = "passer";
      this.user.username = this.form.username;
      this.user.role = this.ROLE;
      this.user.nom = this.form.nom;
      this.user.prenom = this.form.prenom;
      this.user.etat = true;

      //this.user.photo = this.photo;
      console.log("Client", this.client);
      console.log("User", this.user);
      console.log("Adresse", this.adresse);
      console.log("Photo", this.photo);

      this.authService.register(this.user).subscribe(
        (userCreated) => {
          console.log("User Inserted man!!");
          console.log("Inserted user object", userCreated);
          //On verifie si le user a bien été crée
          if (userCreated) {
            /**         Ajout Client     **/
            this.client.user = userCreated;
            console.log("user give to client ", this.client);
            this.clientService.insertData(this.client).subscribe(
              (clientCreated) => {
                for (let a of this.tabaddresss) {
                    a.client = clientCreated;
               // console.log(clientCreated);
                this.adresseService.insertData(a).subscribe(
                  (data) => {
                    console.log(data);
                    this.retour();
                  },
                  (err) => { }
                );
                }
               // this.retour();
              },
              (err) => { }
            );
          }

        },
        (err) => {
          this.errorMessage = err.error.message;
          this.isSignUpFailed = true;
        }
      );
    }
  }

  retour() {
    window.history.back();
  }

  onImageChange(event) {
    let image = event.target.files[0];

    this.ng2ImgMax.resizeImage(image, 140, 140).subscribe(
      (result) => {
        this.uploadedImage = new File([result], result.name);
        //this.onImageChange2(this.uploadedImage);
        this.getImagePreview(this.uploadedImage);
        //this.getBase642(this.uploadedImage);
      },
      (error) => {
        console.log("😢 Oh no!", error);
      }
    );
  }
  getImagePreview(file: File) {
    const reader: FileReader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      const imagePreview: string = reader.result as string;
      this.imagePreview2 = imagePreview;
      this.user.photo = imagePreview;
      this.photo = imagePreview;
      console.log("Image resize base64", reader.result);
      console.log("Image lenght", this.imagePreview2.length);
    };
  }
}
